module.exports = __webpack_public_path__ + "assets/img/login-logo.a6a47ea0.png";